import WorkspaceSwitcher from "./WorkspaceSwitcher/WorkspaceSwitcher";
import SupportalHeader from "../../views/supportal/SupportalHeader";
import CRMSettingsLinks from "./CRMSettingsLinks/CRMSettingsLinks";
import { Workspace } from "../../types/WorkspaceInterfaces";
import BasicCustomLink from "./CustomLinks/BasicCustomLink";
import CustomLinks2 from "./CustomLinks/CustomLinks2";
import QuickNoteLink from "./QuickNote/QuickNoteLink";
import CollapseIconLink from "./CollapseIconLink";
import SidebarAdd from "./SidebarAdd/SidebarAdd";
import Divider from "../../elements/Divider";
import SidebarHeader from "./SidebarHeader";
import IconLink, { Link } from "./IconLink";
import ModuleLinks from "./ModuleLinks";
import OptionList from "./OptionList";
import IconTitle from "./IconTitle";

interface Props {
  open: boolean;
  link: Link;
  workspace: Workspace;
  toggleOpen: () => void;
}

const SidebarLinkFormatter = ({ open, link, workspace, toggleOpen }: Props) => {
  const sidebarLinkSwitch = () => {
    switch (link.type) {
      case "SupportalHeader":
        return (
          <SupportalHeader key={link.id} open={open} toggleOpen={toggleOpen} />
        );
      case "SidebarHeader":
        return (
          <SidebarHeader toggleOpen={toggleOpen} open={open} key={link.id} />
        );
      case "WorkspaceSwitcher":
        return <WorkspaceSwitcher sidebarOpen={open} key={link.id} />;
      case "SidebarAdd":
        return <SidebarAdd key={link.id} />;
      case "IconLink":
        return <IconLink open={open} link={link} key={link.id} />;
      case "Divider":
        return <Divider css={link?.css} key={link.id} />;
      case "QuickNote":
        //@ts-ignore
        return <QuickNoteLink sidebarOpen={open} key={link.id} />;
      case "CustomLink":
        return <BasicCustomLink sidebarOpen={open} link={link} key={link.id} />;
      case "CRMSettings":
        return <CRMSettingsLinks open={open} key={link.id} />;
      case "ModuleLinks":
        return <ModuleLinks open={open} key={link.id} />;
      case "CRMCustomLinks":
        return (
          <CustomLinks2
            key={link.id}
            sidebarItems={workspace?.Sidebar ?? []}
            appsVisibility={workspace?.AppsVisibility}
            reorderEnabled
          />
        );
      case "OptionList":
        return <OptionList sidebarOpen={open} key={link.id} item={link} />;
      case "CollapseIconLink":
        return (
          <CollapseIconLink
            item={link}
            type={link?.pageType}
            sidebarOpen={open}
            key={link.id}
          />
        );
      case "IconTitle":
        return <IconTitle key={link.id} open={open} link={link} />;
      default:
        console.error("Invalid link type passed to Sidebar.");
        return null;
    }
  };

  return <>{sidebarLinkSwitch()}</>;
};

export default SidebarLinkFormatter;
